export default {
  name: 'ThemePlayground',

  data () {
    return {
      colors: [{}]
    }
  },

  mounted: function () {
    const theme = this.$vuetify.theme.themes.light
    this.colors = Object.keys(theme).map(k => ({ color: theme[k], label: k, menu: false }))
  },

  methods: {
    handleColor (color) {
      const currentColor = this.colors.find(color => color.menu)
      this.$vuetify.theme.themes.light[currentColor.label] = color
    },
    handleExport () {
      console.log(this.colors.reduce((acc, next) => ({ ...acc, [next['label']]: next['color'] }), {})) //eslint-disable-line
    }
  }
}
